import { SuccessOverlayProps } from 'components/SuccessOverlay';

export const SUCCESS_OVERLAY_SUCCESS_PROPS: SuccessOverlayProps = {
  variant: 'success',
  message: 'Payment received',
  subMessage:
    'Thank you, your payment has been successfully received. You will shortly be redirected back to your job, or you can click the button below to go there now.',
  buttonText: 'Return to job',
  buttonClassName: 'w-full',
};

export const SUCCESS_OVERLAY_CANCELLED_PROPS: SuccessOverlayProps = {
  variant: 'cancelled',
  message: 'Payment cancelled',
  subMessage:
    'Your payment has been cancelled. You will shortly be redirected back to your job to decide on a payment method, or you can click the button below to go there now.',
  buttonText: 'Return to job',
  buttonClassName: 'w-full',
};

export const SUCCESS_OVERLAY_UNKNOWN_PROPS: SuccessOverlayProps = {
  variant: 'unknown',
  message: 'Unknown payment status received',
  subMessage:
    'Kanda has received an unknown payment status for this payment. Please reach out to Kanda for help via our help chat, or click the button below to return to your job and try your payment again',
  buttonText: 'Return to job',
  buttonClassName: 'w-full',
};

export const SUCCESS_OVERLAY_LOADING_PROPS: SuccessOverlayProps = {
  variant: 'loading',
  message: 'Checking payment status',
  subMessage: 'Please wait a moment',
};
